<template>
  <div class="w-full border border-2 p-1 rounded-lg h-[17rem]">
    <!-- Header: icon + title + tooltip -->
    <div class="d-flex gap-4">
      <div
        :class="iconBg"
        class="rounded py-[2px] px-[4px]"
      >
        <span :class="[iconClass, iconColor, 'text-3xl']" />
      </div>
      <span class="font-semibold align-self-center text-[16px] text-[#626262] text-uppercase">{{ title }}</span>
      <span
        :id="`tooltip-${computedTooltipId}`"
        class="k-info-circle align-self-center text-xl text-[#08A0F7]"
      />
      <b-tooltip
        :target="`tooltip-${computedTooltipId}`"
        triggers="hover"
        variant="light"
      >
        <div class="text-start">
          <div class="mb-1">
            <b>{{ computedTooltipTitle }}</b>
          </div>
          <div>{{ tooltipText }}</div>
        </div>
      </b-tooltip>
    </div>

    <!-- Count + Persentase -->
    <div class="d-flex gap-3 mt-1 pl-1">
      <div class="font-semibold text-3xl text-black">
        <b-spinner
          v-if="count === null"
          small
          variant="primary"
        />
        <span v-else>{{ count }}</span>
      </div>
      <div
        v-if="showPercent"
        class="align-self-center py-[3px] px-[5px] bg-[#D9E7FD] text-[#4285F4] rounded-pill text-xs"
        style="border: solid 1px #4285F4"
      >
        <b-spinner
          v-if="countOfSend === null"
          small
          variant="info"
        />
        <span v-else>{{ percent }}</span>
        <span>% dari jumlah pengiriman</span>
      </div>
    </div>

    <!-- Detail breakdown dari konfigurasi -->
    <div
      v-if="showDetails && detailsConfig && detailsConfig.length"
      class="mt-1 px-1 text-[#828282]"
    >
      <div
        v-for="(item, idx) in detailsConfig"
        :key="idx"
        class="d-flex justify-between"
      >
        <div class="d-flex place-items-center">
          <div
            :class="item.bulletColor"
            class="mr-1 p-[5px] w-[5px] h-[5px] rounded rounded-pill"
          />
          <span class="align-self-center">{{ item.label }}</span>
        </div>
        <div class="font-semibold text-black">
          {{ details[idx] ? details[idx].count : '-' }}
        </div>
      </div>
    </div>

    <!-- Scoped slot untuk konten breakdown tambahan (misal detail sub-status) -->
    <slot :details="details" />

    <!-- Action button dari konfigurasi -->
    <div
      v-if="showAction && actionConfig"
      class="w-full my-1"
    >
      <b-button
        variant="primary"
        block
        @click="$router.push({ name: actionConfig.routeName, params: { date } })"
      >
        <span
          v-if="actionConfig.iconClass"
          :class="actionConfig.iconClass"
        />
        <span class="mx-[5px]">{{ actionConfig.buttonText }}</span>
        <span
          v-if="actionConfig.rightIconClass"
          :class="actionConfig.rightIconClass"
        />
      </b-button>
    </div>

    <!-- Slot untuk action button (opsional) -->
    <slot name="action" />
  </div>
</template>

<script>
export default {
  name: 'CardMetric',

  props: {
    /** Nilai metric yang dikirim ke API: 'received' | 'broken' | 'lost' | 'return' | 'sent' */
    metric: { type: String, required: true },
    title: { type: String, required: true },
    tooltipId: { type: String, default: null },
    tooltipTitle: { type: String, default: null },
    tooltipText: { type: String, required: true },
    iconClass: { type: String, required: true },
    iconColor: { type: String, required: true },
    iconBg: { type: String, required: true },
    errorMessage: { type: String, default: null },
    countOfSend: { type: Number, default: null },
    date: { type: String, default: null },
    shipping: { type: Object, default: null },
    showPercent: { type: Boolean, default: true },
    showDetails: { type: Boolean, default: false },
    detailsConfig: { type: Array, default: () => [] },
    showAction: { type: Boolean, default: false },
    actionConfig: { type: Object, default: null },
  },

  data() {
    return {
      count: null,
      details: [],
    }
  },

  computed: {
    percent() {
      if (!this.count || !this.countOfSend) return 0
      return ((this.count / this.countOfSend) * 100).toFixed(2)
    },
    computedTooltipId() {
      return this.tooltipId || this.metric
    },
    computedTooltipTitle() {
      return this.tooltipTitle || this.title
    },
    computedErrorMessage() {
      return this.errorMessage || `Gagal Mendapatkan Data ${this.title}`
    },
  },

  watch: {
    date(newVal) {
      if (newVal !== null) this.getCount()
    },
    shipping(newVal) {
      if (newVal !== null) this.getCount()
    },
  },

  mounted() {
    this.getCount()
  },

  methods: {
    async getCount() {
      try {
        const params = {
          metric: this.metric,
          date: this.date,
          shipping: this.shipping?.shipping_name,
        }
        const res = await this.$http_new.get('/komship/api/v1/delivery-insight', { params })
        const { data } = res.data
        this.count = data.count
        this.details = data.details || []
        this.$emit('update', this.count)
      } catch {
        this.$toast_error({ message: this.computedErrorMessage })
      }
    },
  },
}
</script>
